export default {
    'privacy.title': '隱私權政策',
} as Record<string, string>;
